export class PasswordRequirementValidator {

  private _minimumCharacterLength: number = 8;

  private _password: string;
  private _confirmPassword: string;

  private _strength: PasswordStrength;
  constructor() {
    this._strength = new PasswordStrength();
  }

  evaluate(password: string, confirmPassword: string): PasswordStrength {
    this._password = password;
    this._confirmPassword = confirmPassword;

    this.reset();

    // Compare
    this._strength.passwordsMatch = this._password == this._confirmPassword;

    // Contains lower character
    if (this._password.match(/[a-z]/)) {
      this._strength.hasLower = true;
    }

    // Contains uppercase character
    if (this._password.match(/[A-Z]/)) {
      this._strength.hasUpper = true;
    }

    // Contains a number
    if (this._password.match(/([0-9])/)) {
      this._strength.hasNumber = true;
    }

    // Contains at least one special character
    if (this._password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
      this._strength.hasSpecialCharacter = true;
    }

    // Meets minimum characters
    if (this._password.length >= this._minimumCharacterLength) {
      this._strength.hasMinimumCharacters = true;
    }

    return this._strength;
  }

  private reset() {
    if (this._strength) {
      this._strength.passwordsMatch = false;
      this._strength.hasUpper = false;
      this._strength.hasLower = false;
      this._strength.hasNumber = false;
      this._strength.hasSpecialCharacter = false;
      this._strength.hasMinimumCharacters = false;
    }
  }

}

export class PasswordStrength {
  hasUpper: boolean = false;
  hasLower: boolean = false;
  hasNumber: boolean = false;
  hasSpecialCharacter: boolean = false;
  hasMinimumCharacters: boolean = false;
  passwordsMatch: boolean = false;

  constructor() { }
  get isValid(): boolean {
    return this.hasUpper && this.hasLower && this.hasNumber && this.hasSpecialCharacter && this.hasMinimumCharacters;
  }

  get strength(): number {
    var strength: number = 0;

    strength = this.hasLower ? (strength + 1) : (strength + 0);
    strength = this.hasUpper ? (strength + 1) : (strength + 0);
    strength = this.hasNumber ? (strength + 1) : (strength + 0);
    strength = this.hasSpecialCharacter ? (strength + 1) : (strength + 0);
    strength = this.hasMinimumCharacters ? (strength + 1) : (strength + 0);

    return strength;
  }
}
